import React from "react";
import { Redirect, useParams } from "react-router";

import NominationView from "screens/events/component/nomination/view";
import { useSelector } from "react-redux";
import { getEventData } from "features/shared-event/redux/selectors";

function Nomination() {
  const { hash } = useParams();
  const eventData = useSelector(getEventData);
  const isOnlineEvent = Boolean(eventData?.live_links);

  if (!eventData) {
    return <Redirect to={`/share/${hash}`} />;
  }

  return (
    <NominationView
      guestName={eventData.guest_first_name}
      nominatedBy={eventData.invited_by}
      isOnlineEvent={isOnlineEvent}
    />
  );
}

export default Nomination;
